import React from "react"
import Container from "../../atoms/Container"
import "./Support.css"
import ArrowRight from "../../atoms/Icons/ArrowRight"

export default function Support({ block }) {
  return (
    <Container>
      <div className="vt-whitespace-container"></div>
      <div className="vt-support-container">
        <div className="vt-support-container-1">
          <div className="vt-support-titel-icon">
            <img src={block.supportBlok.titelIcon.icon.localFile.publicURL} />
            <h3>{block.supportBlok.titelIcon.titel}</h3>
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: block.supportBlok.tekst }}
          ></div>
          <div className="vt-support-button">
            <div
              dangerouslySetInnerHTML={{ __html: block.supportBlok.cta }}
            ></div>
            <ArrowRight />
          </div>
        </div>
        <div className="vt-support-container-2">
          <div className="vt-support-titel-icon">
            <img src={block.supportBlok2.titelIcon.icon.localFile.publicURL} />
            <h3>{block.supportBlok2.titelIcon.titel}</h3>
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: block.supportBlok2.tekst }}
          ></div>
          <div className="vt-support-button">
            <div
              dangerouslySetInnerHTML={{ __html: block.supportBlok2.cta }}
            ></div>
            <ArrowRight />
          </div>
        </div>
        <div className="vt-support-container-3">
          <div className="vt-support-titel-icon">
            <img src={block.supportBlok3.titelIcon.icon.localFile.publicURL} />
            <h3>{block.supportBlok3.titelIcon.titel}</h3>
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: block.supportBlok3.tekst }}
          ></div>
          <div className="vt-support-button">
            <div
              dangerouslySetInnerHTML={{ __html: block.supportBlok3.cta }}
            ></div>
            <ArrowRight />
          </div>
        </div>
      </div>
      <div className="vt-whitespace-container"></div>
    </Container>
  )
}
